import * as types from '../constants/actionTypes';
import {addNotification as notify} from 'reapop';
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as fogActions from "./fog";
import * as authHandler from "../utils/authHandler";
import {saveAs} from 'file-saver';

export function generatingDocuments(user) {
    return {
        type: types.GENERATING_DOCUMENT,
    };
}

export function doneGeneratingDocuments() {
    return {
        type: types.DONE_GENERATING_DOCUMENT,
    };
}

export function failedGeneratingDocuments(message) {
    return {
        type: types.ERROR_GENERATING_DOCUMENT,
        payload: message
    };
}

export function generateDocuments(fogID, type, displayAllFogs = false, documentDate) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/pdf/export/" + type + "/" + fogID + "/" + Math.round(documentDate.getTime() / 1000);
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        dispatch(generatingDocuments());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(doneGeneratingDocuments());
                dispatch(fogActions.fetchFogs(true, displayAllFogs));
            })
            .catch((error) => {
                dispatch(failedGeneratingDocuments(error.message));
                dispatch(notify({message: error.message, status: 'error'}));
            });
    };
}

export function downloadDocument(url, filename) {
    return dispatch => {
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                console.log("Saving blob as " + filename);
                saveAs(blob, filename);
            })
            .catch((error) => {
            });
    };
}

export function downloadCanceledDocument(url, filename) {
    return dispatch => {
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                console.log("Saving blob as " + filename);
                saveAs(blob, filename);
            })
            .catch((error) => {
            });
    };
}

function getFilename(str) {
    return str.split('\\').pop().split('/').pop();
}

export function downloadFile(url) {
    let filename = getFilename(url);
    if (filename === '') {
        filename = 'file.pdf';
    }

    return dispatch => {
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {headers: headers})
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                console.log("Saving blob as " + filename);
                saveAs(blob, filename);
            })
            .catch((error) => {
            });
    };
}

export function cancellingDocuments() {
    return {
        type: types.CANCEL_DOCUMENT,
    };
}

export function doneCancellingDocuments() {
    return {
        type: types.DONE_CANCEL_DOCUMENT,
    };
}

export function failedCancellingDocuments(message) {
    return {
        type: types.ERROR_CANCEL_DOCUMENT,
        payload: message
    };
}

export function cancelDocuments(fogID, type, displayAllFogs = false, documentDate) {

    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + `/pdf/export/${type}/${fogID}/`+  Math.round(documentDate.getTime() / 1000) + `/1`;

        console.log('// type //', type);
        console.log('// FogId //', fogID);
        console.log('// Ajax Root //', ajaxRoutes.API_ROUTE);


        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        dispatch(cancellingDocuments());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(doneCancellingDocuments());
                dispatch(fogActions.fetchFogs(true, displayAllFogs));
            })
            .catch((error) => {
                dispatch(failedCancellingDocuments(error.message));
                dispatch(notify({message: error.message, status: 'error'}));
            });
    };
}

export function directDownload(url, filename) {
    return dispatch => {
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        let filename;

        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    const message = "Error : " + response.status + " please contact Ideative, something went wrong with the download."
                    alert(message)
                    throw new Error(message);
                }
                filename = response.headers.get('content-disposition').split("filename=")[1];
                filename = filename.replaceAll(' ', '_').replaceAll(':', '-').replaceAll('"', '')
                return response.blob()
            })
            .then((data) => {
                console.log("Saving blob to " + filename);
                saveAs(data, filename);
            })
            .catch((error) => {
                console.log(error)
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/documents.js